<h3 class="not-found">Page not found</h3>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/not-found/not-found.component.html